var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Rz=require("ttag");module.exports=$CLJS.Rz;